<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17vzMk9/tc-custom/9781615951758.jpg?1718077835764" alt="This image is the cover for the book Three for a Letter, John, the Lord Chamberlain Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Three for a Letter, John, the Lord Chamberlain Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>It's 539 AD, and John the Lord Chamberlain finds his investigations hampered by squabbling courtiers, servants with social ambitions, an eccentric host, and an egotistic inventor—not to mention a herd of prophesying goats and a protective whale. The Mithran Anatolius and the excubitor captain Felix only add to John's worries when they fall under the spell of two ambitious women. Can the trio avoid Theodora's wrath as they work to protect a child and stop a heartless killer? Does the solution lie within the villa where all have assembled, back in Constantinople, or in some other world altogether?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Reed, Eric Mayer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c909db4